//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
	async fetch() {
		await Promise.all([ 
			this.$store.dispatch('resourcesStore/getResources', this.queries.providers),
			this.$store.dispatch('pagesStore/getPage', 'provider')
		])
	},
	head() {
		return {
			title: this.pages.provider && this.pages.provider.seo ? this.pages.provider.seo.title : 'TV-zender ontvangen | Info | Meiden van Holland',
			meta: [
				{ hid: 'title', name: 'title', content: this.pages.provider && this.pages.provider.seo ? this.pages.provider.seo.title : 'TV-zender ontvangen | Info | Meiden van Holland' },
				{ hid: 'og:title', name: 'og:title', content: this.pages.provider && this.pages.provider.seo ? this.pages.provider.seo.title : 'TV-zender ontvangen | Info | Meiden van Holland' },
				{ hid: 'description', name: 'description', content: this.pages.provider && this.pages.provider.seo ? this.pages.provider.seo.description : 'Meiden van Holland heeft landelijke dekking. Op deze pagina zie je waar je ons kan bekijken.'},
				{ hid: 'og:description', name: 'og:description', content: this.pages.provider && this.pages.provider.seo ? this.pages.provider.seo.description : 'Meiden van Holland heeft landelijke dekking. Op deze pagina zie je waar je ons kan bekijken.' },
				{ hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/info/tv-zender-ontvangen' },
				{ hid: 'keywords', name: 'keywords', content: this.pages.provider && this.pages.provider.seo ? this.pages.provider.seo.keywords : 'TV-zender, ontvangen, providers, waar te zien'},
			]
		}
	},
	components: {
		provider: () => import('~/components/content/provider/provider'),
		dummy: () => import('~/components/content/dummy/default')
	},
	computed: {
		...mapState({
			queries: ({ resourcesStore: {queries} }) => queries,
			pages: ({ pagesStore: {pages} }) => pages,
			providers: ({ resourcesStore: {providers} }) => providers,
			loading: ({ resourcesStore: { loading } }) => loading
		}),
	},
}
